module.exports = __webpack_public_path__ + "img/appstore-badge-300.1f37d08f.png";